export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker.54204f29.worker.js");
}
